import { Routes as AppRoutes, BrowserRouter, Route } from "react-router-dom";
import { LoginScreen } from "../Login/LoginScreen";
import { NoMatch } from "../Login/NoMatch";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import { WallboardOne } from "../WallboardOne";
import { WallboardTwo } from "../WallboardTwo";

export function Routes() {
    return (
        <BrowserRouter>
            {/* <ScrollToTop /> */}
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<LoginScreen />} />
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route
                        path="/wallboard"
                        element={<WallboardOne />}
                    />
                    <Route
                        path="/wallboard_two"
                        element={<WallboardTwo />}
                    />
                </Route>

                {/* NO MATCH ROUTES */}
                <Route path="*" element={<NoMatch />} />
            </AppRoutes>
        </BrowserRouter>
    );
}